import React from 'react';

import { FormControlLabel, Switch, Box, FormHelperText } from '@mui/material';

export default function DealOpportunityZoneField({
  value,
  error,
  setValue,
  setError,
}) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={value}
            onChange={() => {
              setValue(!value);
            }}
          />
        }
        label='Opportunity Zone'
      />
      <FormHelperText>
        Property is located in a Qualified Opportunity Zone.
      </FormHelperText>
    </Box>
  );
}
